import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditPencil from '../../../../../Assets/StorefrontIcons/EditPencil.svg';
import { setSectionType, setSectionFormType } from '../../../../../Features/storefrontSlice';
import { formatDescription } from '../../../../../lib/utils/utils';

function AboutOne({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descHeight, setDescHeight] = useState(0);

    const [textGap, setTextGap] = useState(0);

    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setHeadingSize((zoomSize/100)*20);
        setHeadingHeight((zoomSize/100)*28);

        setDescSize((zoomSize/100)*14);
        setDescHeight((zoomSize/100)*26);

        setTextGap((zoomSize/100)*4);

        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    const dispatch = useDispatch();

    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('ABOUT_THREE'));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            style={{ paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} 
            className='flex flex-col relative'
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                </div>
            }

            <img className='w-full h-auto' src={item?.item?.imageLink} alt={item.item.altText} />

            <div style={{ gap: `${textGap}px` }} className="w-full flex flex-col font-medium absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-6">
                <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='text-[#FFFFFF]'>{item.item.Heading}</h1>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descHeight}px` }} className='text-[#FFFFFF]'>
                    <span dangerouslySetInnerHTML={{ __html: formatDescription(item.item.Description || '') }} />
                </p>
            </div>
        </div>
    );
}

export default AboutOne;
